import React from 'react';

const PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.jelarose.monalerte';
const text = { margin: 0, color: '#A0A0A0', lineHeight: 1.5 };

/**
 * Parcours partagé (/rando/…) ou parcours programmé (/sortie/…). Avec l'app installée, le lien
 * s'ouvre directement dedans ; sinon cette page explique comment le rejoindre.
 */
export default function OutingInvitePage({ planned = false }) {
  return (
    <div style={{ minHeight: '100vh', background: '#0B0B0F', color: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ maxWidth: 480, width: '100%', background: '#15151C', border: '1px solid #2A2A35', borderRadius: 16, padding: 24, display: 'flex', flexDirection: 'column', gap: 16 }}>
        <h1 style={{ margin: 0, fontSize: 22, color: '#FACC15' }}>{planned ? 'Invitation à un parcours' : 'Parcours partagé'}</h1>
        <p style={text}>
          {planned
            ? 'Une personne vous invite à faire un parcours avec elle. Dans MonAlerte, vous voyez le tracé, l’heure du départ et qui vient ; le jour venu, vous rejoignez la sortie et chacun voit où sont les autres.'
            : 'Une personne partage un parcours de randonnée avec vous. Dans MonAlerte, vous pouvez le voir, l’enregistrer et le faire, en sécurité.'}
        </p>
        <p style={text}>
          Installez l’application MonAlerte et connectez-vous, puis <strong>rouvrez ce lien depuis votre téléphone</strong> :
          il s’ouvrira dans l’application.
        </p>
        <a href={PLAY_STORE} style={{ textAlign: 'center', padding: 12, borderRadius: 10, background: '#FACC15', color: '#000', fontWeight: 700, textDecoration: 'none' }}>
          Installer MonAlerte
        </a>
      </div>
    </div>
  );
}
